import { useIntl } from "react-intl";
import { Modal, Box, IconButton, Button, Typography } from "@mui/material";
import PageHeader from "../ui/PageHeader";
import { useEffect, useState } from "react";
import { useLoading } from "../LoadingContext";
import axios from "../../api/axiosClient";
import {
  handleError,
  errorToast,
  addDownloadLinkToDocument,
} from "../../services/serviceBase";
import CustomGridHeaderCell from "../ui/CustomGridHeaderCell";
import CustomTable from "../ui/CustomTable";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const DiagramModal = (props) => {
  const intl = useIntl(); 
  const navigate = useNavigate();

  const modalStyle = {
      position: "relative",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      bgcolor: "white",
      boxShadow: 24,
      width: '75%',
      p: 4,
      borderRadius: "5px",
      overflowY: "auto",
      maxHeight: 500,
  };

  const { setLoading } = useLoading();

  const [historyRaData, setHistoryRaData] = useState([]);
  const [historyDataColumns, setHistoryDataColumns] = useState([]);
  

  useEffect(() => {
    if (
      props.idReturnFileHead !== null &&
      props.idReturnFileHead !== undefined &&
      props.idReturnFileHead !== "" &&
      props.openModal
    ) {
      getHistoryData();
      getHistoryDataColumns();
    }
    
  }, [props.openModal]);

  useEffect(() => {
    getHistoryDataColumns();
  }, [historyRaData]);

  const getHistoryData = () => {
    setLoading(true);
    axios
      .get("/returnfiles/" + props.idReturnFileHead + "/history")
      .then((response) => {
        setLoading(false);
        var groupedHeaderItems = [];
        if (response.data.headers != [] && response.data.headers.length > 0) {
          response.data.headers.forEach((header) => {
            var groupedRowItems = [];
            const { idReturnFileHead, returnFileKey, relationType, isExtra } = header;
            groupedHeaderItems.push({
              idReturnFileHead: idReturnFileHead,
              returnFileKey: returnFileKey,
              relationType: relationType,
              items: groupedRowItems,
              isExtra: isExtra,
            });

            header.items.forEach((row) => {
              const { idRFHeadStatesLog, rfStateCode, date, returnFileKey, idHOrderHeader, lastChangeUser, action, previousRFStateCode } = row;
              groupedRowItems.push({
                idRFHeadStatesLog: idRFHeadStatesLog,
                rfStateCode: rfStateCode,
                date: date,
                returnFileKey: returnFileKey,
                idHOrderHeader: idHOrderHeader,
                lastChangeUser: lastChangeUser,
                action: action,
                previousRFStateCode: previousRFStateCode,
                isExtra: isExtra,
              });
            }, {});
          }, {});
        }
        setHistoryRaData(groupedHeaderItems);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleCliclkReturnFileKey = (idHOrderHeader, returnFileKey) => {    
    var message = intl.formatMessage({ id: "General.ChangeDossierConfirmMessage" }, { 0: returnFileKey });
    if (
      props.idReturnFileHead != idHOrderHeader &&
      window.confirm(message)
    ) {
      navigate("/QCDetail/" + idHOrderHeader);  
    }
    
  }

  const getHistoryDataColumns = () => {
    setHistoryDataColumns([
      {
        field: "returnFileKey",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "RA.ReturnFileKey" })}
          </Typography>
        ),
        renderCell: (params) => {
          if(props.idReturnFileHead != params.row.idHOrderHeader){
            return(
              <Button disableRipple={true}  mt={1} sx={{ fontSize: "15px" }} onClick={() =>{handleCliclkReturnFileKey(params.row.idHOrderHeader, params.row.returnFileKey)}}>
                {params.row.returnFileKey}
              </Button>
           );
          }
          else{
            return (
              <Typography mt={1} sx={{ fontSize: "15px" }}>
                {params.row.returnFileKey}
              </Typography>
            );
          }
        },
        cellClassName: (params) => {
          return params.row.isExtra ? "extraQtyDossier" : "";
        },
        flex: 1,
        minWidth: 220,
      },
      {
        field: "rfStateCode",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "RA.State" })}
          </Typography>
        ),
        cellClassName: (params) => {
          return params.row.isExtra ? "extraQtyDossier" : "";
        },
        flex: 1,
        minWidth: 200,
      },
      {
        field: "date",
        headerClassName: "grid-header apeLigthBlueBackground ",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "RA.Date" })}
          </Typography>
        ),
        cellClassName: (params) => {
          return params.row.isExtra ? "extraQtyDossier" : "";
        },
        flex: 1,
        minWidth: 180,
        valueFormatter: (value) => {
          return moment(value).format("YYYY-MM-DD HH:mm:ss");
        },
      },
      {
        field: "lastChangeUser",
        headerClassName: "grid-header apeLigthBlueBackground ",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.User" })}
          </Typography>
        ),
        flex: 1,
        minWidth: 150,
        cellClassName: (params) => {
          return params.row.isExtra ? "extraQtyDossier" : "";
        },
      },
      {
        field: "action",
        headerClassName: "grid-header apeLigthBlueBackground ",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "General.Action" })}
          </Typography>
        ),
        flex: 1,
        minWidth: 150,
        cellClassName: (params) => {
          return params.row.isExtra ? "extraQtyDossier" : "";
        },
      },
      {
        field: "previousRFStateCode",
        headerClassName: "grid-header apeLigthBlueBackground ",
        renderHeader: () => (
          <Typography sx={{ color: "white" }}>
            {intl.formatMessage({ id: "RA.PreviousState" })}
          </Typography>
        ),
        flex: 1,
        minWidth: 200,
        cellClassName: (params) => {
          return params.row.isExtra ? "extraQtyDossier" : "";
        },
      },
    ]);
  };

  const handleClose = () => {
    props.handleCloseModal();
    setHistoryRaData([]);
  };

  return (
    <Modal open={props.openModal} onClose={handleClose}>
      <Box sx={modalStyle}>
        <PageHeader
          title={intl.formatMessage({ id: "RADetails.HistoryRA" })}
        />
        {historyRaData.map((header) => {
          let tableHeight = 60 + 40 * header.items.length;
          return (
            <Box id="modal-modal-description" sx={{ mt: 2 }}>
              <CustomTable
                columns={historyDataColumns}
                rows={header.items}
                id={"idRFHeadStatesLog"}
                rowHeight={40}
                headerHeight={30}
                tableHeight={tableHeight}
                isExtra={header.isExtra}
              />
            </Box>
          );
        })}
      </Box>
    </Modal>
  );
};

export default DiagramModal;
